// extracted by mini-css-extract-plugin
module.exports = {"container":"OntodiaContents--container","items":"OntodiaContents--items"};